import React from 'react';
import '../styles/styles.scss';

const Loading = () => {
  return (
    <div className="background loading">&nbsp;</div>
  );
};

export default Loading;
